export const APP_NAME = 'Share video | Faces';
export const API_URL = 'https://faces-backend.wowmaking.net/api/video/share';

export const GOOGLE_PLAY_LINK = 'https://app.adjust.com/g9bigvn';
export const APP_STORE_LINK = 'https://app.adjust.com/g9bigvn';